
import { Component, Vue } from 'vue-property-decorator'
import MaterialSelect from '@/components/material-select/index.vue'
import { apiCategoryLists,apiIntegralCategoryAdd, apiIntegralCategoryDetail, apiIntegralCategoryEdit } from '@/api/application/integral_mall'
@Component({
    components: {
        MaterialSelect
    }
})
export default class AddBrand extends Vue {
    $refs!: { form: any }
    id!: any
    loading = false
    hasPid = 0
  categoryList = []
    form = {
        name: '',
      pid: '',
        image: '',
        sort: '',
        is_show: 1
    }

    rules = {
        name: [
            {
                required: true,
                message: '请输入分类名称',
                trigger: ['blur', 'change']
            }
        ]
    }

    handleSave() {
        this.$refs.form.validate((valid: boolean, object: any) => {
            if (valid) {
              if (!this.hasPid) {
                this.form.pid = ''
              }
                const ref = /[^0-9]/g
                if(ref.test(this.form.sort)) {
                    this.$message.error('排序必须是数字')
                    return
                }
                const api = this.id ? apiIntegralCategoryEdit(this.form) : apiIntegralCategoryAdd(this.form)
                api.then(() => {
                    this.$router.go(-1)
                })
            } else {
                return false
            }
        })
    }

    getBrandDetail() {
        this.loading = true
        apiIntegralCategoryDetail(this.id).then((res: any) => {
          if (res.pid) {
            this.hasPid = 1
          }
            this.form = res
            this.loading = false
        })
    }

  getCategoryList() {
    apiCategoryLists({ page_type: 1 }).then((res: any) => {
      res?.lists.forEach((item: any) => {
        item.sons &&
        item.sons.forEach((sitem: any) => {
          delete sitem.sons
        })
      })
      this.categoryList = res?.lists
    })
  }

    created() {
        this.id = this.$route.query.id
        this.id && this.getBrandDetail()
      this.getCategoryList()
    }
}
